import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

export const supportedLanguages = ["ru", "en"] as const;

export const i18nNamespaces = [
  "common",
  "auth",
  "apps",
  "stations",
  "incidents",
  "audit"
] as const;

export const i18n = i18next.createInstance();

void i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: [...supportedLanguages],
    fallbackLng: "ru",
    defaultNS: "common",
    ns: [...i18nNamespaces],
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json"
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"]
    },
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });
